import React from 'react';
import { useFeatureFlags } from 'components/shared/hooks';
import PracticeRecordingQuestion from 'components/Questions/PracticeRecordingQuestion/PracticeRecordingQuestion';

const screenConfig = {
  screenRecord: true,
  audio: true,
  webCam: false,
  resolution: '1080',
  tabRecording: false,
  separateLayer: false,
  fromPopup: true,
  initiator: 'generic_embed',
};

const ScreenRecordingQuestion = props => {
  const {
    prompt,
    hippoPreviewBase,
    handleSave,
    questionId,
    setAnswer,
    resetAnswer,
    currentUserId,
    apiKey,
  } = props;

  const hasZiggeoForAllMedia = useFeatureFlags(['ziggeo_for_all_media']);
  return (
    <PracticeRecordingQuestion
      questionId={questionId}
      recordingConfig={screenConfig}
      setAnswer={setAnswer}
      resetAnswer={resetAnswer}
      handleSave={handleSave}
      hippoPreviewBase={hippoPreviewBase}
      prompt={prompt}
      currentUserId={currentUserId}
      apiKey={apiKey}
      hasZiggeoForAllMedia={hasZiggeoForAllMedia}
      provider={hasZiggeoForAllMedia ? 'ziggeo' : 'hippo_video'}
    />
  );
};

export default ScreenRecordingQuestion;
